import React from "react";
import "../../Styles/ClientProfileSelection.css";
import { useNavigate } from "react-router-dom";
import { IoChevronBackOutline } from "react-icons/io5";
import { FiUser } from "react-icons/fi";
import { HiOutlineUserGroup } from "react-icons/hi2";

export default function ClientProfileSelection() {
  const navigate = useNavigate();

  const handleSelection = (type) => {
    navigate("/client_setup", {
      state: {
        profileType: type,
      },
    });
  };

  return (
    <div className="client-profile-selection-main">
      {/* HEADER */}
      <div className="client-profile-selection-header">
        <div
          className="client-profile-selection-header-left"
          onClick={() => navigate(-1)}
        >
          <IoChevronBackOutline className="client-profile-selection-back-icon" />

          <img
            src={require("../../assests/images/nav_bar_logo.png")}
            alt="logo"
            className="client-profile-selection-logo"
          />
        </div>

        <div className="client-profile-selection-header-right">
          <span> Profile setup</span>
        </div>
      </div>

      {/* BODY */}
      <div className="client-profile-selection-body">
        <div className="client-profile-selection-card">
          <h2>Great let’s setup your first profile</h2>

          <p>
            Whether you're here for yourself or helping a family member, you can
            manage create and manage multiple profiles from one account.
          </p>

          <div className="client-profile-selection-options">
            {/* SELF */}
            <div
              className="client-profile-selection-option active-selection"
              onClick={() => handleSelection("self")}
            >
              <img
                src={require("../../assests/images/Create_self_icon.png")}
                alt="self"
                className="client-profile-selection-image-icon"
              />

              <h3>Create profile for self</h3>
            </div>

            {/* PARENT */}
            <div
              className="client-profile-selection-option"
              onClick={() => handleSelection("parent")}
            >
              <img
                src={require("../../assests/images/Create_Son_icon.png")}
                alt="parent"
                className="client-profile-selection-image-parent"
              />

              <h3>Create profile for relative/child</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
